import {
    useLocation,
    Navigate,
    Outlet,
} from 'react-router-dom';

export default function NoAuth() {
    const loggedInUser = localStorage.getItem("user-token");
    const userData = JSON.parse(localStorage.getItem("user-data"));
  
    if (loggedInUser) {
      if(userData[0].userType==0){//servant
        // var navigateTo = "/civil-servant"
        var navigateTo = userData[0].similer_training ? "/civil-servant" : "/civil-servant/survey"
      }else if(userData[0].userType==1){//mentor
        // var navigateTo = "/mentor"
        var navigateTo = userData[0].similer_training ? "/mentor" : "/mentor/survey"
      }else if(userData[0].userType==2){//admin
        var navigateTo = "/secure/dashboard"
      }

      return <Navigate to={navigateTo} />;
    }
  
    return <Outlet />;
}

export function RequireAuthServant() {
    const loggedInUser = localStorage.getItem("user-token");

    let location = useLocation();
  
    if (!loggedInUser) {
        return <Navigate to="/login" state={{ from: location }} />;
    }else{
        const userData = JSON.parse(localStorage.getItem("user-data"));
        if(userData[0].userType!=0){//servant
            if(userData[0].userType==1){//mentor
                // var navigateTo = "/mentor"
                var navigateTo = userData[0].similer_training ? "/mentor" : "/mentor/survey"
            }else if(userData[0].userType==2){//admin
                var navigateTo = "/secure/dashboard"
            }

            return <Navigate to={navigateTo} />;
        } 
    }
  
    return <Outlet />;
}

export function RequireAuthMentor() {
    const loggedInUser = localStorage.getItem("user-token");

    let location = useLocation();
  
    if (!loggedInUser) {
        return <Navigate to="/login" state={{ from: location }} />;
    }else{
        const userData = JSON.parse(localStorage.getItem("user-data"));
        if(userData[0].userType!=1){//mentor
            if(userData[0].userType==0){//servant
                // var navigateTo = "/civil-servant"
                var navigateTo = userData[0].similer_training ? "/civil-servant" : "/civil-servant/survey"
            }else if(userData[0].userType==2){//admin
                var navigateTo = "/secure/dashboard"
            }

            return <Navigate to={navigateTo} />;
        } 
    }
  
    return <Outlet />;
}

export function RequireAuthAdmin() {
    const loggedInUser = localStorage.getItem("user-token");

    let location = useLocation();
  
    if (!loggedInUser) {
        return <Navigate to="/secure" state={{ from: location }} />;
    }else{
        const userData = JSON.parse(localStorage.getItem("user-data"));
        if(userData[0].userType!=2){//admin
            if(userData[0].userType==0){//servant
                // var navigateTo = "/civil-servant"
                var navigateTo = userData[0].similer_training ? "/civil-servant" : "/civil-servant/survey"
            }else if(userData[0].userType==1){//mentor
                // var navigateTo = "/mentor"
                var navigateTo = userData[0].similer_training ? "/mentor" : "/mentor/survey"
            }

            return <Navigate to={navigateTo} />;
        } 
    }
  
    return <Outlet />;
}
